// extracted by mini-css-extract-plugin
export var productImage = "_xu-0";